import { Checkbox } from 'antd'
import Search from 'components/ui/FormElements/Search'
import Loader from 'components/ui/Loader'
import { getAllTopics, getAllTopicsVariables } from 'graphql/query/__generated__/getAllTopics'
import { GET_ALL_TOPICS } from 'graphql/query/getAllTopics'
import useDebouncedValue from 'hooks/useDebouncedValue'
import { ChangeEvent, useEffect, useState } from 'react'

import { useQuery } from '@apollo/client'

import { EmptyContainer, EmptyText } from '../../../Home/styled'
import { ShiurimFilters } from '../index'
import { DownArrow } from '../styled'
import { Item, List, ShowMoreText, ShowMoreWrapper, Title } from './styled'

type Props = { filters: ShiurimFilters; onChangeFilters: (filters: ShiurimFilters) => void }

const initialPagination = {
  take: 6,
  page: 1,
}

function TopicFilter({ filters, onChangeFilters }: Props) {
  const [search, setSearch] = useState('')
  const searchDebounced = useDebouncedValue(search, 300)
  const [page, setPage] = useState(initialPagination.page)
  const [loadingNext, setLoadingNext] = useState(false)

  useEffect(() => {
    setPage(initialPagination.page)
  }, [search])

  const { data, loading, fetchMore } = useQuery<getAllTopics, getAllTopicsVariables>(GET_ALL_TOPICS, {
    variables: {
      title: searchDebounced,
      ...initialPagination,
    },
  })

  const onFetchMore = async () => {
    setLoadingNext(true)

    await fetchMore({
      variables: { take: initialPagination.take, page: page + 1 },
      updateQuery(previousQueryResult, { fetchMoreResult }) {
        return {
          ...fetchMoreResult,
          getAllTopics: {
            ...previousQueryResult.getAllTopics,
            ...fetchMoreResult.getAllTopics,
            items: [...previousQueryResult.getAllTopics.items, ...fetchMoreResult.getAllTopics.items],
          },
        }
      },
    })

    setPage((prev) => prev + 1)
    setLoadingNext(false)
  }

  const onChangeTopics = (topicId: string, topicTitle: string, checked: boolean) => {
    if (checked) {
      onChangeFilters({ ...filters, topics: [...(filters.topics || []), { title: topicTitle, id: topicId }] })
    } else {
      onChangeFilters({ ...filters, topics: [...(filters.topics?.filter((el) => el.id !== topicId) || [])] })
    }
  }

  const items = data?.getAllTopics?.items
  return (
    <div>
      <Search
        placeholder="Search topics..."
        value={search}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
      />
      <List>
        {loading ? (
          <Loader />
        ) : !items?.length ? (
          <EmptyContainer>
            <EmptyText>No topics found</EmptyText>
          </EmptyContainer>
        ) : (
          <>
            {items?.map(({ topicId, title }) => (
              <Item key={topicId}>
                <Title>{title}</Title>
                <Checkbox
                  checked={!!filters.topics?.find((el) => el.id === topicId)}
                  onChange={(e) => onChangeTopics(topicId, title, e.target.checked)}
                />
              </Item>
            ))}
            {loadingNext ? (
              <Loader noHeight />
            ) : (
              data?.getAllTopics?.meta?.next && (
                <ShowMoreWrapper onClick={onFetchMore}>
                  <ShowMoreText>Show more</ShowMoreText>
                  <DownArrow />
                </ShowMoreWrapper>
              )
            )}
          </>
        )}
      </List>
    </div>
  )
}

export default TopicFilter
